import { useCallback, useEffect, useState } from "react";
import { IframeProps } from "./Iframe.types";
import { Skeleton } from "@commonlibs";
import InnerIframe from "./InnerIframe";

function Iframe({ onLoadStart, onLoad, ...rest }: IframeProps) {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        onLoadStart?.();
    }, []);

    const handleOnLoad = useCallback(
        (event: React.SyntheticEvent<HTMLIFrameElement, Event>) => {
            setLoading(false);
            onLoad?.(event);
        },
        [onLoad],
    );

    return (
        <Skeleton loading={loading}>
            <InnerIframe onLoad={handleOnLoad} {...rest} />
        </Skeleton>
    );
}

export default Iframe;
